const API_BASE_URL = (process.env.REACT_APP_API_URL ?? '/api').replace(/\/$/, '');

export function getApiBaseUrl(): string {
  return API_BASE_URL;
}

export function getNotificationsHubUrl(): string {
  const apiBase = getApiBaseUrl();

  if (apiBase.startsWith('http://') || apiBase.startsWith('https://')) {
    const url = new URL(apiBase);
    url.pathname = '/hubs/notifications';
    url.search = '';
    url.hash = '';
    return url.toString();
  }

  return `${window.location.origin}/hubs/notifications`;
}
